import React, { useState, useEffect, useRef } from 'react';
import useResourceForm from './hooks/useResourceForm';
import { AcceptResourcesProps, AcceptResourcesPublicProps } from './AcceptResources.props';
import AcceptResourcesView from './AcceptResources.view';
import { IResponsesDB } from 'interfaces/response.interface';

const AcceptResourcesContainer: React.FC<AcceptResourcesPublicProps> = (
  publicProps: AcceptResourcesPublicProps,
) => {
  const { requestResponse } = publicProps;
  const [tabIndex, setTabIndex] = useState<number>(0);
  const form = useResourceForm();

  const initializedRef = useRef(false);

  useEffect(() => {
    if (requestResponse && !initializedRef.current) {
      form.reset(requestResponse);
      initializedRef.current = true;
    }
  }, [form, requestResponse]);

  const handleAccept = (accept: boolean, payload: IResponsesDB) => () => {
    if (publicProps.onAccept) publicProps.onAccept(accept, payload);
  };

  const handleDecline = (decline: boolean, payload: IResponsesDB) => () => {
    if (publicProps.onDecline) publicProps.onDecline(decline, payload);
  };

  const combinedProps: AcceptResourcesProps = {
    ...publicProps,
    form,
    tabIndex,
    handleAccept,
    handleDecline,
    handleTabChange: (e: React.SyntheticEvent, index: number) => setTabIndex(index),
  };
  return <AcceptResourcesView {...combinedProps} />;
};

export default AcceptResourcesContainer;
